import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import { toOptions } from "LIB/forms";
import {
  Select,
  FormInput,
  CheckGroup,
  Check
} from "MODULES/shared/components/Forms";
import { CARRIERS, TBD } from "MODULES/shared/constants";
import withFormFields from "MODULES/shared/decorators/withFormFields";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import {
  ACCOUNT_NUMBER,
  CARRIER,
  SHIPPING_METHOD,
  SHIPPING_OPTIONS
} from "APP_ROOT/constants";
import { properCase } from "LIB/formatters/text";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import { SimpleCopy } from "MODULES/Shipping/components/Dashboard/Create/Form";

function ShippingMethod({
  account_number: accountNumber,
  carrier,
  doNotShip,
  required,
  disabled = false,
  setTenantAccount,
  shipping_method: shippingMethod,
  wtDimsReq,
  selectedCarrier,
  selectedShippingMethod,
  selectedAccountNumber
}) {
  useEffect(
    () => {
      if (selectedCarrier) {
        carrier.input.onChange(selectedCarrier);
      }
      if (selectedShippingMethod) {
        shippingMethod.input.onChange(selectedShippingMethod);
      }
      if (selectedAccountNumber) {
        accountNumber.input.onChange(selectedAccountNumber);
      }
    },
    [
      selectedCarrier,
      selectedShippingMethod,
      selectedAccountNumber,
      carrier,
      shippingMethod,
      accountNumber
    ]
  );

  const addCurrentMethod = availMethods =>
    shippingMethod &&
    shippingMethod.input.value &&
    CARRIERS[carrier.input.value].shippingMethods[shippingMethod.input.value] &&
    !availMethods.includes(shippingMethod.input.value);

  const shippingCarriers = () => {
    if (!wtDimsReq && carrier.input.value !== TBD) {
      // eslint-disable-next-line
      const { tbd, ...filteredCarriers } = CARRIERS;
      return filteredCarriers;
    }
    return CARRIERS;
  };

  const shippingMethods = () => {
    if (!carrier.input.value) {
      return [];
    }
    if (carrier.input.value === TBD) {
      shippingMethod.input.onChange("dim_weight");
    }
    const { shippingMethods: methods } = CARRIERS[carrier.input.value];
    const availMethods = Object.keys(methods).filter(
      t => !methods[t].deprecated
    );
    const activeShippingMethods = availMethods.map(t => ({
      value: t,
      text: methods[t].label
    }));
    return addCurrentMethod(availMethods)
      ? [
          ...activeShippingMethods,
          {
            value: shippingMethod.input.value,
            text:
              CARRIERS[carrier.input.value].shippingMethods[
                shippingMethod.input.value
              ].label
          }
        ]
      : activeShippingMethods;
  };

  const settings = useSettings();

  return (
    <div>
      <FormRow>
        {wtDimsReq && (
          <Col md={3}>
            <CheckGroup title="Req Wt & Dims from Warehouse" justified>
              <Field name="request_weight_dims" component={Check} label="Yes" />
            </CheckGroup>
          </Col>
        )}
        <Col md={3}>
          <Field
            name={CARRIER}
            component={Select}
            label={properCase(CARRIER)}
            onChange={(_, val) => {
              if (!setTenantAccount) return null;
              const defaultAcct = get(
                settings,
                `${SHIPPING_OPTIONS}.${val}.default_account`
              );
              if (defaultAcct) {
                accountNumber.input.onChange(defaultAcct);
              }

              return null;
            }}
            options={toOptions(shippingCarriers())}
            required={required && !doNotShip}
            disabled={disabled || doNotShip}
          />
        </Col>
        <Col md={6}>
          <Field
            name={SHIPPING_METHOD}
            component={Select}
            label="Method"
            options={shippingMethods()}
            disabled={!carrier.input.value || disabled || doNotShip}
            required={required && !doNotShip}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col md={4}>
          <Field
            name={ACCOUNT_NUMBER}
            component={FormInput}
            disabled={disabled}
            label={[
              "Account #",
              <SimpleCopy value={accountNumber.input.value} bottom={"25px"} />
            ]}
          />
        </Col>
      </FormRow>
    </div>
  );
}

ShippingMethod.propTypes = {
  account_number: F.formField(F.stringInput).isRequired,
  carrier: F.formField(F.stringInput).isRequired,
  disabled: PropTypes.bool,
  doNotShip: PropTypes.bool,
  required: PropTypes.bool,
  setTenantAccount: PropTypes.bool,
  shipping_method: PropTypes.shape({
    input: PropTypes.shape({
      value: PropTypes.string
    })
  }),
  wtDimsReq: PropTypes.bool,
  selectedCarrier: PropTypes.string,
  selectedShippingMethod: PropTypes.string,
  selectedAccountNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

ShippingMethod.defaultProps = {
  required: true
};

export default withFormFields(ShippingMethod, [
  ACCOUNT_NUMBER,
  CARRIER,
  SHIPPING_METHOD
]);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FormSections/ShippingMethod/ShippingMethod.jsx